import React from "react";
import { useParams } from "react-router-dom";
import { useGetTaskQuery } from "../../features/api/Tasks/tasksApi";
import Error from "../ui/Error";
import Form from "./Form";

export default function EditTaskItem() {

  const { id: currentTaskId } = useParams();
  const { data: task, isLoading, isError } = useGetTaskQuery(currentTaskId);

  let content = null;

  if (isLoading) {
      content = <div>Loading...</div>;
  }
  if (!isLoading && isError) {
      content = <Error message="There was an error!" />;
  }
  if (!isLoading && !isError && task?.id) {
      content = <Form task={task} />;
  }

  return (
    <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
      <h1 className="mt-4 mb-8 text-3xl font-bold text-center text-gray-800">
        Edit Task for Your Team
      </h1>

      {content}
    </main>
  );
}
